export default __webpack_public_path__ + "static/media/succes.f83338f0.svg";